import { ReactNode, useEffect, useState } from 'react';
import reactDom from 'react-dom';
const Portal = ({
  children,
  targetId
}: {
  children: ReactNode;
  targetId: string;
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  const targetElement = document.getElementById(targetId);
  return mounted && targetElement ? reactDom.createPortal(children, targetElement) : null;
};
export default Portal;